// extracted by mini-css-extract-plugin
export default {"top_nav":"nav_top_nav__rzgm4","icons":"nav_icons__HYtg-"};